import { render, staticRenderFns } from "./Categorii_cpv.vue?vue&type=template&id=59e130f8"
import script from "./Categorii_cpv.vue?vue&type=script&lang=js"
export * from "./Categorii_cpv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports